import { setProjectFestivalCalculateOptions } from '@/domain/project-festival/actions/set-project-festival-calculate-options.action';
import { CalculateOptions } from '@/domain/project-festival/entities/project-festival.entity';
import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { runImpactCalculateCo2ForProject } from './run-impact-calculate-co2-for-project.action';

type Params = {
  include: boolean;
};

export const changeIncludePublicAnswersForCo2 = createAppAsyncThunk(
  'impactCalculate/changeIncludePublicAnswersForCo2',
  async (
    params: Params,
    { extra: { projectFestivalGateway, snackbarGateway }, dispatch, getState },
  ): Promise<void> => {
    try {
      // get festival project
      const project = selectCurrentProjectFestival(getState());
      if (!project) {
        throw new Error('No project found');
      }
      // update includePublicAnswersForCo2 value
      const newCalculateOptions: CalculateOptions = {
        ...project.calculateOptions,
        includePublicAnswersForCo2: params.include,
      };
      const newProject = {
        ...project,
        calculateOptions: newCalculateOptions,
      };
      // save the project
      await projectFestivalGateway.edit(newProject);
      // ask for new co2 calculation
      await dispatch(
        runImpactCalculateCo2ForProject({ projectId: project.id }),
      );
      // if we do a dispatch(getProjectFestival(project.id)),
      // the festival object well be replaced and the festival page will be updated
      // so we'll update manualy the calculateOptions.includePublicAnswersForCo2
      await dispatch(setProjectFestivalCalculateOptions(newCalculateOptions));
      // show snackbar success
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditProject.Message.error'));
}

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditProject.Message.success'));
}
